// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const RoleSuperadminIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path
        d="M21.9 4.03c-.43-.25-.97-.21-1.36.1l-3.9 3.17c-.83-.92-2.82-3.15-3.74-4.2-.46-.5-1.34-.5-1.8 0L7.37 7.3l-3.9-3.16c-.4-.32-.94-.36-1.38-.1-.43.25-.66.74-.57 1.24.28 1.6.9 5.82 1.24 8.2C3 15.2 4.5 16.5 6.26 16.5h11.48c1.75 0 3.25-1.3 3.5-3.03.34-2.37.96-6.59 1.24-8.19.09-.5-.14-.99-.58-1.25"
        opacity=".5"
      />
      <path d="M19.37 19.29H4.63c-.46 0-.83.44-.83 1 0 .54.37.99.83.99h14.74c.45 0 .82-.45.82-1s-.37-1-.82-1" />
    </g>
  </SvgIcon>
);

export default RoleSuperadminIcon;
